import { type CarrierDef } from './common.js'
import { password, username } from './internal.js'

type StandardCarrierDef<TCredType extends string> = Omit<
  CarrierDef<TCredType>,
  'scac' | 'name' | 'engineLayers'
>

/////////////////////////
const carrierLogisticsCredTypes = [username, password] as const

export type CarrierLogisticsCredType =
  (typeof carrierLogisticsCredTypes)[number]

export const carrierLogistics: StandardCarrierDef<CarrierLogisticsCredType> = {
  credentialTypes: carrierLogisticsCredTypes,
  legacyCredMap: [
    ['username', 'username'],
    ['password', 'password'],
  ],
}

////////////////////////////////
// maybe a better name for this one?  TQuote & TPickup use the same creds
const tQuoteApiCredTypes = [username, password] as const
const tQuoteLocationCredTypes = ['iam-code'] as const
export type TQuoteApiCredTypes =
  | (typeof tQuoteApiCredTypes)[number]
  | (typeof tQuoteLocationCredTypes)[number]
export const tQuoteApi: StandardCarrierDef<TQuoteApiCredTypes> = {
  credentialTypes: tQuoteApiCredTypes,
  locationCredentialTypes: tQuoteLocationCredTypes,
  legacyCredMap: [
    ['username', 'username'],
    ['password', 'password'],
    ['iam-code', 'ref1'],
  ],
  credentialConfig: {
    'iam-code': { nonsensitive: true },
  },
}
////////////////////////////////
const roadVisionApiCredTypes = [username, password] as const
export type RoadVisionCredTypes = (typeof roadVisionApiCredTypes)[number]
export const roadVision: StandardCarrierDef<RoadVisionCredTypes> = {
  credentialTypes: roadVisionApiCredTypes,
  legacyCredMap: [
    ['username', 'username'],
    ['password', 'password'],
  ],
}
